export default "__VITE_ASSET__a51dd5f2__"